import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/paypal': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M111.4 295.9C107.9 315.1 94 404.6 89.9 429.9 89.6 431.7 88.9 432.4 86.9 432.4H12.3C4.7 432.4-0.8 425.8 0.2 418.5L58.8 46.6C60.3 37 68.9 29.7 78.8 29.7 231.1 29.7 243.9 26 282.8 41.1 342.9 64.4 348.4 120.6 326.8 181.4 305.3 244 254.3 270.9 186.7 271.7 143.3 272.4 117.2 264.7 111.4 295.9zM357.1 152C355.3 150.7 354.6 150.2 354.1 153.3 352.1 164.7 349 175.8 345.3 186.9 305.4 300.7 194.8 290.8 140.8 290.8 134.7 290.8 130.7 294.1 129.9 300.2 107.3 440.6 102.8 469.9 102.8 469.9 101.8 477 106.3 482.8 113.4 482.8H176.9C185.5 482.8 192.6 476.5 194.3 467.9 195 462.5 193.2 474 208.7 376.6 213.3 354.6 223 356.9 238 356.9 309 356.9 364.4 328.1 380.9 244.6 387.4 209.8 385.5 173.2 357.1 152z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/paypal.js
// module id = iikV
// module chunks = 144